module.exports = __webpack_public_path__ + "static/media/icon-plane-submain.73f64042.svg";